import React from 'react';

/**
 * StatCard — dashboard KPI tile.
 *
 * `trend` shape:
 *   { value: string, positive: bool, hint?: string, baselineZero?: bool }
 * `hint` appears in a small muted line under the delta (e.g. "vs last 30 days").
 * `baselineZero` renders the arrow-with-no-percent "New" chip when the previous
 * window had no data — used by the /analytics/overview endpoint.
 */
export default function StatCard({ icon: Icon, label, value, trend, accent = 'primary', testId }) {
  const accents = {
    primary: { bg: '#EAE8FF', icon: '#6C5CE7' },
    wa: { bg: '#DCF8E8', icon: '#1DA851' },
    orange: { bg: '#FFEDD5', icon: '#FF6B35' },
    blue: { bg: '#DBEAFE', icon: '#3B82F6' },
    success: { bg: '#D1FAE5', icon: '#00C896' },
  };
  const a = accents[accent] || accents.primary;
  return (
    <div className="fab-card p-5 flex flex-col gap-3 hover:shadow-md transition-shadow" data-testid={testId}>
      <div className="flex items-start justify-between">
        {Icon && (
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: a.bg }}>
            <Icon className="w-5 h-5" style={{ color: a.icon }} />
          </div>
        )}
        {trend && (
          <div className="text-right leading-tight">
            <span
              className="text-[11px] font-semibold inline-flex items-center gap-0.5"
              style={{ color: trend.baselineZero ? '#9191A8' : (trend.positive ? '#00C896' : '#EF4444') }}
              data-testid={testId ? `${testId}-trend` : undefined}
            >
              {trend.baselineZero ? '•' : (trend.positive ? '↗' : '↘')}{' '}
              {trend.baselineZero ? 'New' : trend.value}
            </span>
            {trend.hint && (
              <div className="text-[10px] text-fab-text-muted mt-0.5">{trend.hint}</div>
            )}
          </div>
        )}
      </div>
      <div>
        <div className="text-[12px] text-fab-text-muted uppercase tracking-wider font-medium">{label}</div>
        <div className="font-display text-[24px] font-bold text-fab-text mt-1">{value}</div>
      </div>
    </div>
  );
}
